import { TSelectOption } from '@/common/types/select';
import { getYearsFilterOptions } from '@/common/utils/options';

export const getDashboardsYearsOptions = () => {
  return getYearsFilterOptions(2024);
};

export const getIsIncludeYear = (options: TSelectOption<string | number>[], year: string) =>
  options.some((option) => Number(option.value) === Number(year));
